import axios from "axios";
import { useState } from "react";
import { toast} from "react-toastify";



const AgentFileUpload = ({agentId,handleToggleSection,setRefreshData}) => {
    const [selectedFile, setSelectedFile] = useState(null);

    // Handle file selection
    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
    };
  
    // Handle form submission
    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!selectedFile) {
        toast.error("No file selected", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
        return ;
      }
  
      // Prepare the form data
      const formData = new FormData();
      formData.append('agent_file', selectedFile);
      formData.append('agentId', agentId);
  
      try {
        // Send the POST request
        const res = await axios.post(`${process.env.REACT_APP_API_URL}agent_document_upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        
        if(res.data.success){
            toast.success(res.data.message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
            setRefreshData(prev => !prev);
            handleToggleSection();
        }

        // Handle the res
        


        setSelectedFile(null); // Clear the selected file
      } catch (error) {
          toast.error(error?.response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
      }
    };
  


    return (        <form className="form" style={{ maxWidth: "40rem" }} onSubmit={handleSubmit}>
            <div className="form-group">
                <label htmlFor="agent_file"></label>
                <input 
                    className="form-control" 
                    type="file" 
                    id="agent_file" 
                    name="agent_file"
                    onChange={handleFileChange}/>
            </div>
            <div className="mt-3">
                <button className="btn btn-secondary me-3" onClick={handleToggleSection}>Document Table</button>
                <button type="submit" className="px-4 py-2">Upload</button>
            </div>
        </form>
    );

}



export default AgentFileUpload;